import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { DashboardLayout } from "../../components/DashboardLayout";
import { links } from "./SuperAdminPages";

export default function SubscriptionRequests() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [reasons, setReasons] = useState({});
  const [busy, setBusy] = useState("");
  const refresh = useCallback(async () => {
    try { const response = await api.get("/subscriptions/requests"); setItems(response.data.items); setError(""); }
    catch (e) { setError(e?.response?.data?.detail || "Unable to load subscription requests."); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const reject = async item => {
    setBusy(item.request_id);
    try { await api.post(`/subscriptions/clinic/${item.clinic_id}/request/reject`, { kind: item.kind, reason: reasons[item.request_id], request_id: item.request_id }); await refresh(); }
    catch (e) { setError(e?.response?.data?.detail || "Unable to record review."); }
    setBusy("");
  };
  return <DashboardLayout links={links} title="Plan and renewal requests">
    <p className="mb-4 text-sm">Review the clinic and approved payment terms before activation. Renewal requests do not constitute payment.</p>
    {error && <div role="alert" className="mg-card text-red-700">{error}<button className="mg-btn-secondary ml-3" onClick={refresh}>Retry</button></div>}
    {items === null && !error && <p>Loading requests…</p>}
    {items?.length === 0 && <p className="mg-card">No pending requests.</p>}
    <div className="space-y-4">{items?.map(item => <article key={item.request_id} className="mg-card">
      <h2 className="font-bold">{item.clinic_name} · {item.kind === "plan" ? `Plan: ${item.plan_name}` : "Renewal"}</h2>
      <p className="text-sm mt-2">{item.reason}</p><p className="text-xs mt-1">Requested {item.requested_at}</p>
      <Link className="mg-btn-primary mt-3" to={`/super-admin/clinics/${item.billing_clinic_id || item.clinic_id}/subscription`}>Review subscription and payment</Link>
      <label className="block mt-3 text-sm">Reason if rejecting<input className="mg-input w-full mt-1" maxLength={500} value={reasons[item.request_id] || ""} onChange={e => setReasons({ ...reasons, [item.request_id]: e.target.value })} /></label>
      <button className="mg-btn-secondary mt-2" disabled={!!busy || !reasons[item.request_id]?.trim()} onClick={() => reject(item)}>Reject request</button>
    </article>)}</div>
  </DashboardLayout>;
}
